App.factory('a2pBranding', ['restmod', '$api', (restmod, $api) => {
  return restmod.model().mix({
    $extend: {
      Model: {
        $find: function(params = {}) {
          return $api('GET', `/telephony/a2p/brand_registration`, params);
        },
        $save: function(data) {
          const method = data.editing ? 'PUT' : 'POST';
          return $api(method, `/telephony/a2p/brand_registration`, {}, data);
        },
      }
    }
  })
}])
